<template>
  <div class="tree-wrap">
    <div class="project-selector">
      <el-row :gutter="10">
        <el-col :span="16">
          <el-select
            size="mini"
            style="width: 100%"
            v-model="jurisdictionId"
            filterable
            remote
            reserve-keyword
            clearable
            placeholder="请输入项目名称搜索"
            :remote-method="remoteMethod"
            :loading="loading"
            class="kuan"
            @clear="getProjectList">
            <el-option
              v-for="item in jurisdictionList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-button title="点击重新刷新房产树" size="mini" @click="getDataObj" icon="el-icon-refresh" circle></el-button>
        </el-col>
      </el-row>
    </div>
    <div class="el-tree-1" :style="{height: height}">
      <el-tree ref="tree" :data="data" :empty-text="emptyText" :props="defaultProps" :lazy="true" :load="getData" @node-click="nodeClick">
        <div slot-scope="{ node }">
          <span v-if="node.data.type==='room'" class="fangtai" :class="roomStatusIoc(node.data.room_status_ids)"></span>
          <span class="fangtai-name">{{ node.label }}</span>
      </div>
      </el-tree>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'erp-tree-status-common',
    props: {
      api: {
        type: String,
        default() {
          return ""
        }
      },
      height:{
        type:String,
        default() {
            return "calc( 100vh - 220px )";
        }
      }
    },
    data() {
      return {
        jurisdictionId: '',
        jurisdictionList: [],
        projectId: 0,
        building: '',
        unit: '',
        data: [],
        emptyText: '没有数据',
        defaultProps: {
          label: 'name',
          isLeaf: 'leaf',
        },
        loading: false,
      }
    },
    created() {
      this.getJurisdiction()
      this.getProjectList()
    },
    watch: {
      jurisdictionId(val) {
        this.getProjectList()
      }
    },
    methods: {
      getDataObj(){
        this.data=[];
        this.jurisdictionId= '';
        this.jurisdictionList= [];
        this.projectId=0;
        this.building=''
        this.unit=''
        this.defaultProps= {
          label: 'name',
          isLeaf: 'leaf',
        }
        this.getJurisdiction()
        this.getProjectList()
      },
      // 获得自己和自己名下的架构
      getJurisdiction() {
        this.$myhttp.get('admin/common/jurisdiction',{
        'Content-Type': 'application/json'
        }).then(backdata=>{
        	if(backdata.data.code == 200) {
        	  this.jurisdictionList = backdata.data.data
        	} else {
            this.$message.error(backdata.data.message);
        	}
        });
      },

      // 获得自己名下的所有项目
      getProjectList() {
        this.$myhttp.get('admin/common/pindex?projectId=' + this.jurisdictionId,{
          'Content-Type': 'application/json'
        }).then(backdata=>{
        	if(backdata.data.code == 200) {
            this.data = backdata.data.data.map((item) => {
              //return {id: item.id, name: item.name, type: 'project'}
              return {'name':item.name,'id':item.id,'region':0,'type':'project','pindex_id':item.id,superior:'0','projectId':item.id,dataObj:item}
            })
          } else {
            this.$message.error(backdata.data.message);
          }
        });
      },

      // 根据架构获得项目（废弃）
      getProjectListByJurisdiction(jurisdictionId) {
        this.$myhttp.get(`admin/common/jurisdictionPindex?jurisdiction_id=${jurisdictionId}`,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
        	if(backdata.data.code == 200) {
        	  this.data = backdata.data.data.map((item) => {
              //return {id: item.id, projectId: item.id, name: item.name, type: 'project'}
              return {'name':item.name,'id':item.id,'region':0,'type':'project','pindex_id':item.id,superior:'0','projectId':item.id,dataObj:item}
            })
        	} else {
            this.$message.error(backdata.data.message);
        	}
        });
      },

      getData(node, resolve) {

        //console.log(node.level, node.data)
        var region_id = node.data.id;
        //console.log(region_id);
        var _this = this;
        setTimeout(() => {
          if(region_id == '' || region_id == undefined){
            return false;
          }
          //加载
          node.data.region_id = region_id;
          node.data && this.$myhttp.post('admin/common/getbindingArrs',node.data,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            // _this.defaultcheckedkeys =  _this.arr;
            return resolve(backdata.data);
          });
        }, 300);

        // switch(node.level) {

        //   case 1:
        //     this.projectId = node.data.id
        //     this.$myhttp.get(`admin/common/pindexId?pindex_id=${this.projectId}`,{
        //       'Content-Type': 'application/json'
        //     }).then(backdata=>{
        //       if(backdata.data.code == 200) {
        //         resolve(backdata.data.data.map((item, index) => {
        //           return {id: index, projectId: node.data.id, name: item.building, type: 'building'}
        //         }))
        //       } else {
        //         this.$message.error(backdata.data.message);
        //       }
        //     });
        //     break;

        //   case 2:
        //     this.building = node.data.name
        //     this.$myhttp.get(`admin/common/buildingUnitOrRoom?pindex_id=${node.data.projectId}&building=${node.data.name}`,{
        //       'Content-Type': 'application/json'
        //     }).then(backdata=>{
        //     	if(backdata.data.code == 200) {
        //     	  resolve(backdata.data.data.map((item, index) => {
        //           return {id: item.id, projectId: node.data.projectId, building: node.data.name, unit: item.unit, name: item.stutes ? item.unit : item.room, leaf: !item.stutes, type: item.stutes ? 'unit' : 'room',dataObj:item.stutes?{}:item}
        //     	  }))
        //     	} else {
        //     	  this.$message.error(backdata.data.message);
        //     	}
        //     });
        //     break;

        //   case 3:
        //     if(node.isLeaf == false) {
        //       this.unit = node.data.name
        //       this.$myhttp.get(`admin/common/getRoot?pindex_id=${node.data.projectId}&building=${node.data.building}&unit=${node.data.unit}`,{
        //         'Content-Type': 'application/json'
        //       }).then(backdata=>{
        //       	if(backdata.data.code == 200) {
        //       	  resolve(backdata.data.data.map((item, index) => {
        //       	    return {id: item.id, name: item.room, leaf: true, type: 'room',dataObj:item}
        //       	  }))
        //       	} else {
        //       	  this.$message.error(backdata.data.message);
        //       	}
        //       });

        //     }

        // }

      },
      nodeClick(data, node) {
        var d = {
          level: node.level,
          type: node.data.type,
          id: node.data.id,
          name: node.data.name,
          tree:nodeToList(node),
          cdj_house_id:node.data.superior
        }
        this.$emit('node-click', d)
      },
      roomStatusIoc(ids){
        // 1	空置	空	1	1	开发商未出售的房子
        // 2	未领	锁	2	1	已售、未交楼（出售、入伙）
        // 3	空关	关	4	1	已售、已交楼、未装修、未入住
        // 4	装修	装	8	1	在装修
        // 5	入住	绿人	16	1	已入住
        // 6	出租	租	32	1	已出租
        // 7	停用		64	1
        // 8	其他		128	0
        //chuzu,kongguan,kongzhi,ruzhu,zhuangxiu,tingyong,weiling

        let icons=['kongzhi','weiling','kongguan','zhuangxiu','ruzhu','chuzu','tingyong','qita']

        try {
          ids.findIndex(',')!==-1&&(ids=ids.split(','),ids=ids[0]);
        }catch (e) {
          // console.log(ids)
        }

        return 'fangtai_'+icons[ids-1]
      },
      remoteMethod(query) {
        if (query !== "") {
          this.loading = true;
          setTimeout(() => {
            this.$myhttp
              .post(
                "admin/common/searchProject",
                { keyword: query },
                {
                  "Content-Type": "application/json",
                }
              )
              .then((backdata) => {
                if (backdata.data.code == 200) {
                  this.jurisdictionList = backdata.data.data;
                } else {
                  this.$message.error(backdata.data.message);
                }
              });
            this.loading = false;
          }, 200);
        }
      },
    }
  }

  function nodeToList(node) {
    let node_list=[]
    node_list[10]=node.data;
    let nodeObj=node
    for(let i=9;i>0;i--){
      nodeObj['parent']&&(nodeObj=nodeObj['parent'],node_list[i]=nodeObj.data[0]?nodeObj.data[0]:nodeObj.data);
    }
    return node_list.filter(ret=>{return ret}).splice(1)
  }
</script>

<style lang="scss">
  .el-tree-1{
    overflow-y: scroll;
    //height: calc( 100vh - 120px );
    width: 100%;
  }
  .tree-wrap {
    width: 250px;
  }

  .fangtai{
    width: 18px;
    height: 18px;
    margin-right: 25px;
    position: relative;
    &::before{
      content: " ";
      position: absolute;
      width: 18px;
      height: 18px;
      right: 0;
      left: 0;
      top: 0;
      bottom: 0;
      background-image: url("../../../assets/image/fangtai/chuzu.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      z-index: 99;
    }
  }
  $icons:chuzu,kongguan,kongzhi,ruzhu,zhuangxiu,tingyong,weiling;
  @each $i in $icons{
    .fangtai_#{$i}{
      &::before{
        background-image: url("../../../assets/image/fangtai/#{$i}.png");
      }
    }
  }
  .fangtai-name{

  }

  .project-selector {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/erp-tree-status-common.vue